import type { PluginsStatus } from '@cdf/api-client-react';
import type { AppRole, AppRouteDefinition } from './route-registry';

/** Access checks shared by route mounting and every registry-driven menu. */
export function routeAvailable(
  route: Pick<AppRouteDefinition, 'requiredPlugin' | 'requiredRole' | 'requiredCapability' | 'requiredAnyCapabilities'>,
  plugins: PluginsStatus | undefined,
  role: AppRole | undefined,
  capabilities: readonly string[] | undefined
): boolean {
  if (route.requiredPlugin && plugins?.[route.requiredPlugin]?.status !== 'ready') return false;
  if (route.requiredRole && (!role ||
    (route.requiredRole === 'editor' && role === 'viewer') ||
    (route.requiredRole === 'admin' && role !== 'admin'))) return false;
  if (route.requiredCapability && !capabilities?.includes(route.requiredCapability)) return false;
  if (route.requiredAnyCapabilities?.length &&
    !route.requiredAnyCapabilities.some((capability) => capabilities?.includes(capability))) return false;
  return true;
}
